var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-primary waves-effect rounded-xl",
      class: _vm.w100 ? "w-100" : "",
      attrs: { type: "button" },
      on: { click: _vm.use_coupon },
    },
    [_vm._v(_vm._s(_vm.trans.use_coupon))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }